import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd-mobile";
import React, { useState, useEffect } from "react";

export const shouldShowSignAlert = () => {
  const closedTime = localStorage.getItem("signAlertClosedTime");
  if (!closedTime) {
    return true;
  }
  const now = new Date().getTime();
  const threeDays = 3 * 24 * 60 * 60 * 1000;
  return now - parseInt(closedTime, 10) > threeDays;
};

export default function SignAlert(props) {
  const { data } = props;
  const [selected, setSelected] = useState(false);

  const handleClose = () => {
    Modal.clear();
  };

  const handleSign = () => {
    setTimeout(() => {
      if (props.handleSign) {
        props.handleSign();
      }
    }, 300);
    handleClose();
  };

  const handlePushVip = () => {
    setTimeout(() => {
      if (props.handlePushVip) {
        props.handlePushVip();
      }
    }, 300);
    handleClose();
  };

  useEffect(() => {
    if (selected) {
      localStorage.setItem("signAlertClosedTime", new Date().getTime());
    } else {
      localStorage.removeItem("signAlertClosedTime");
    }
  }, [selected]);

  return (
    <div style={{ position: "relative" }}>
      <img
        src="resources/251222/sign_alert_kthy.png"
        alt=""
        style={{
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1,
        }}
        height={173}
      />
      <div style={{ paddingBottom: 20 }}>
        <div style={{ backgroundColor: "transparent", height: 86 }}></div>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 13,
            overflow: "hidden",
            padding: "0 10px 20px",
            position: "relative",
          }}
        >
          <CloseOutlined
            onClick={handleClose}
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              padding: 10,
              color: "#999",
            }}
          ></CloseOutlined>
          <div>
            <div
              style={{
                background: "linear-gradient(#FFF6EF, #FFF6EF00)",
                height: 80,
              }}
            ></div>
            <div
              style={{
                padding: "10px",
                fontSize: 14,
                color: "#666",
                lineHeight: 1.7,
              }}
            >
              1、每天签到最高额外+5金币； <br />
              2、开卡即送和每月自动赠送代金券；
              <br />
              3、会员享受多项专属特权
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div onClick={handleSign} style={{ position: "relative" }}>
              <img src="resources/251222/ptqd.png" alt="" height={63} />
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: 15, color: "white" }}>普通签到</div>
                  <div style={{ fontSize: 10, color: "white", lineHeight: 1 }}>
                    +1金币
                  </div>
                </div>
              </div>
            </div>
            <div onClick={handlePushVip} style={{ position: "relative" }}>
              <img src="resources/251222/bjjd.png" alt="" height={63} />
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: 15, color: "white" }}>暴击签到</div>
                  <div style={{ fontSize: 10, color: "white", lineHeight: 1 }}>
                    +6金币
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            backgroundColor: "transparent",
            paddingTop: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onClick={() => {
              setSelected((e) => !e);
            }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={
                selected
                  ? "resources/hangup/select.png"
                  : "resources/251222/sign_bzts.png"
              }
              alt=""
              height={16}
            />
          </div>
          <div style={{ fontSize: 12, color: "#999", paddingLeft: 5 }}>
            3天内不再提示
          </div>
        </div>
      </div>
    </div>
  );
}
